export const checkIsValue = (value: any) => value !== undefined && value !== null;
